import { useUserSettings } from "@next-platform/client-common-core";
import { ROUTES } from "@src/constants/navigation";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Text } from "@/components/customComponents";
import SearchClientCharacterListing from "@/components/search/SearchClientCharacterListing";
import Trans from "@/components/Trans/Trans";
import { default as useFavoritesTabs, FavoritesTab } from "@/pages/Favorites/useFavoritesTabs";
import { Collection } from "@/types/api";

const FavoritesLorebooks = () => {
  const { likedLorebooks } = useUserSettings();
  const navigate = useNavigate();
  const { tabItems, onTabChange, hasPublicLorebooks, isLorebooksFlagLoading } = useFavoritesTabs();

  // Never leave the user stranded on a hidden tab if the flag is off.
  useEffect(() => {
    if (!isLorebooksFlagLoading && !hasPublicLorebooks) {
      navigate(ROUTES.favoriteBots, { replace: true });
    }
  }, [hasPublicLorebooks, isLorebooksFlagLoading, navigate]);

  return (
    <>
      <Text h1 className="m-0 px-4 max-mob:px-2" variant="xxl">
        <Trans i18nKey="chatbot:page.favorites.title.lorebooks" />
      </Text>
      <SearchClientCharacterListing
        useStoreTagFilters={false}
        charactersList={likedLorebooks}
        tabItems={tabItems}
        activeTab={FavoritesTab.LOREBOOKS}
        onTabChange={onTabChange}
        collection={Collection.LOREBOOKS}
        defaultSortField={"createdAt:desc"}
      />
    </>
  );
};

export default FavoritesLorebooks;
